import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}${`?latitude=${number}&longitude=${number}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}`;

export const URL = (lat: number, lon: number): RouteDefinition => `${baseRoute}?latitude=${lat}&longitude=${lon}`;
